export default "__VITE_ASSET__272f8d63__"